<template>
  <div class="home">
    <div class="home-img">
      <img src="../assets/images/home/img-1.png" alt>
      <img src="../assets/images/home/img-2.png" alt>
      <img src="../assets/images/home/img-3.png" alt>
    </div>
    <div class="home-products">
      <div class="content">
        <div class="header"> 
          <div class="title">OUR PRODUCTS</div>
          <div class="text">Natural · Healthy · Wonderful</div>
          <div class="divideLine"></div>
        </div>
        <div class="productContent">
          <ul class="nav">
            <li v-for="item in productList" :key="item.name" @click="handleClick(item)" :class="item.isActive ? 'isActive': ''">
              {{ item.name }}
            </li>
          </ul>
          <div class="productImg" id="productImg">
            <img v-for="item in isActiveProductImg" :key="item" :src="require(`../assets/images/home/${item}.png`)" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-content">
        <ul class="content-nav">
          <li>
            <p>OUR STORY</p>
            <span>CULTURE</span>
            <span>INTRODUCTION</span>
            <span>MEMBERS</span>
            <span>PROFILE</span>
            <span>NEWS</span>
          </li>
          <li>
            <p>OUR PRODUCTS</p>
            <span>COCONUT</span>
            <span>SODA</span>
            <span>COFFEE</span>
            <span>LIFE</span>
          </li>
          <li class="contactUsTag">
            <p>CONTACT US</p>
            <img src="../assets/images/home/logo.png" alt="">
          </li>
        </ul>
      </div>
      <div class="beian">
        <div class="company-name">三麟中泰 (厦门) 实业有限公司&nbsp;&nbsp;&nbsp;</div>
        <div class="beian-content">
          <a target="_blank" class="href" href="http://beian.miit.gov.cn">闽ICP备2022012195号&nbsp;&nbsp;&nbsp;</a>
          <img src="../assets/images/home/beian.png" alt="">
          <a target="_blank" class="href" :href="`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${35021102001557}`">闽公网安备 35021102001557号</a>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
export default {
  name: "Home",
  data() {
    return {
      productList: [
        {name: 'COCOUNT', isActive: true, imagelist: ['product-1-1', 'product-1-2', 'product-1-3', 'product-1-4']},
        {name: 'SODA', isActive: false, imagelist: ['product-2-2', 'product-2-1']},
        {name: 'COFFEE', isActive: false, imagelist: ['product-3-1']},
        {name: 'LIFE', isActive: false, imagelist: ['product-5-1', 'product-5-2', 'product-5-3', 'product-5-4']},
        // {name: 'CHANG', isActive: false, imagelist: ['product-4-1', 'product-4-2', 'product-4-3']},
        {name: 'ERAWAN', isActive: false, imagelist: ['product-6-1', 'product-6-2', 'product-6-3' ]},
      ],
      isActiveProductImg: ['product-1-1', 'product-1-2', 'product-1-3', 'product-1-4'],
    };
  },
  created() {},
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    handleClick(item) {
      if(item.isActive) {
        return
      }
      this.productList.map(element => {
        element.isActive = false
      });
      item.isActive = true
      this.isActiveProductImg = item.imagelist
      //  重置商品位置，加载动画
      const imgDom = document.getElementById('productImg')
      imgDom.className = 'productImg' 
      // move： 3 or 4个商品动画， move1: 1个商品动画
      setTimeout(() => {
        imgDom.className = 'productImg  move' 
        if(item.name === 'SODA' || item.name === 'COFFEE') {
          imgDom.className = 'productImg move1' 
        }
      })
    },
    // 判断element是否存在于当前视口中
    isInViewWindow(el) {
      const viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const offsetTop = el.offsetTop;
      const scrollTop = document.documentElement.scrollTop;
      const top = scrollTop - offsetTop;
      return top >= viewPortHeight;
    },
    handleScroll() {
      const imgDom = document.getElementById('productImg')
      if(this.isInViewWindow(imgDom) && imgDom.className.indexOf('move') === -1) {
        imgDom.className += ' move' 
      }
      if(!this.isInViewWindow(imgDom)) {
        imgDom.className = 'productImg' 
      }
    }
  },
};
</script>
 
<style lang="scss" scoped>
.home{
  &-img{
    img{
      height: 100%;
    }
  }
  &-products{
    height: 760px;
    width: 100%;
    background-color:  #EAEAEA;
    .content{
      display: flex;
      flex-direction: column;
      margin: 0 auto;
      width: calc(100% - 96px);
      .header{
        .title{
          width: fit-content;
          font-size: 54px;
          font-weight: bold;
          margin-top: 11px;
          color: #505050;
        }
        .text{
          width: 425px;
          text-align: center;
          font-size: 18px;
          font-weight: 500;
          color: #3D3D3D;
        }
        .divideLine{
          width: 100%;
          border-bottom: 2px solid #505050;
          margin-top: 12px;
        }
      }
      .productContent{
        margin-top: 60px;
        display: flex;
        flex-direction: row;
        position: relative;
        .nav{
          list-style: none;
          width: 200px;
          li{
            color: #505050;
            font-size: 24px;
            font-weight: 300;
            margin-top: 30px;
            cursor: pointer;
          }
          .isActive{
            color: #003191;
            font-size: 36px;
            font-weight: 500;
          }
        }
        .productImg{
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          width: fit-content;
          img{
            height: 400px;
            width: 250px;
            margin-right: 40px;
            &:last-child{
              margin-right: 0;
            }
          }
        }
        .move {
          position: absolute;
          right: -1200px;
          animation: move 1s linear 1;
          animation-fill-mode: both;
        }
        .move1{
          position: absolute;
          right: -300px;
          animation: move1 0.5s linear 1;
          animation-fill-mode: both;
        } 
        @keyframes move{
          0% {right: -1200px; }
          100%{right: 0px; }
        }
        @keyframes move1{
          0%  {right: -300px; }
          100%{right: 0px; }
        }
      }
      
    }
   
    
  }
  .footer{
    width: 100%;
    height: 380px;
    color: #EAEAEA;
    background-color: #003191;
    &-content {
      width: 1440px;
      margin: 0 auto;
      padding-top: 20px;
      display: flex;
      justify-content: space-between;
      position: relative;
      .content-nav {
        display: flex;
        justify-content: space-around;
        margin-left: 105px;
        li {
          display: flex;
          flex-direction: column;
          margin-right: 95px;
          align-items: flex-start;
          color: EAEAEA;
          p {
            font-size: 20px;
            font-weight: 500;
            position: relative;
            padding-bottom: 20px;
            &::after{
              position: absolute;
              content: '';
              width: 23px;
              top: 40px;
              left: 0;
              border: 2px solid #EAEAEA;
            }
          }
          span {
            font-size: 12px;
            font-weight: 300;
            padding: 10px 0px 0px 0px;
            &:first-child{
              padding-top: 50px;
            }
          }
        }
        .contactUsTag{
          position: absolute;
          right: 250px;
          img{
            margin-top: 20px;
          }
        }
      }
    }
    .beian{
      font-weight: normal;
      display: flex;
      flex-direction: row;
      height: 30px;
      line-height: 30px;
      width: fit-content;
      margin: 60px auto 0;
      .company-name{
        width: fit-content;
      }
      .beian-content{
        width: fit-content;
        display: flex;
        flex-direction: row;
        .href{
          color: #EAEAEA;
          text-decoration: none;
          padding: 0;
          margin: 0;
        }
        img{
          height: 20px;
          width: 20px;
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-top: 5px;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>